<template>
    <div>
        <h1 class="display-heading">Clinic List</h1>

        <div id="searchAccordion" role="tablist">
            <div class="card mb-4">
                <a class="card-header filter-collapse-header" role="tab"  id="headingOne" data-toggle="collapse" href="#searchAccordionContent">
                    <p class="mb-0">
                        <i class="fa fa-search" aria-hidden="true"></i> Search Clinics
                    </p>
                </a>
                <div id="searchAccordionContent" class="collapse" role="tabpanel" aria-labelledby="headingOne" data-parent="#searchAccordion">
                    <div class="card-body">
                        <form @submit.prevent="searchFilter">
                            <div class="form-row">
                                <div class="form-group col-md-6">
                                    <label>Join Date</label>
                                    <input type="text" name="joinedDate" data-vv-as="join date"
                                        data-vv-validate-on="blur" v-model="search.joinedDate"
                                        v-mask="'##/##/####'" v-validate="'date_format:DD/MM/YYYY'" placeholder="DD/MM/YYYY"
                                        :class="{
                                        'form-control': true,
                                        'is-invalid':  validationErrors.has('joinedDate')
                                    }" />
                                    <div v-show="validationErrors.has('joinedDate')" class="invalid-feedback">
                                        {{ validationErrors.first('joinedDate') }}
                                    </div>
                                </div>
                                <div class="form-group col-md-6">
                                    <label>Clinic Name</label>
                                    <input type="text" class="form-control" v-model="search.clinicName" />
                                </div>
                            </div>

                            <div class="form-row">
                                <div class="form-group col-md-6">
                                    <label>Email Address</label>
                                    <input type="text" class="form-control" v-model="search.emailAddress" />
                                </div>

                                <div class="form-group col-md-6">
                                    <label>Review Status</label>
                                    <select class="form-control" v-model="search.reviewStatus">
                                        <option v-for="(status, index) in reviewStatuses" :key="index" :value="status.value">
                                            {{status.text}}
                                        </option>
                                    </select>
                                </div>
                            </div>

                            <div class="form-row">
                                <div class="form-group col-md-6">
                                    <label>Approval Status</label>
                                    <select class="form-control" v-model="search.approvalStatus">
                                        <option v-for="(status, index) in approvalStatuses" :key="index" :value="status.value">
                                            {{status.text}}
                                        </option>
                                    </select>
                                </div>
                                <div v-if="isSuperAdmin" class="form-group col-md-6">
                                    <label>Recruitment Type</label>
                                    <select class="form-control" v-model="search.recruitmentType">
                                        <option v-for="(status, index) in recruitmentTypes" :key="index" :value="status.value">
                                            {{status.text}}
                                        </option>
                                    </select>
                                </div>
                            </div>

                            <div>
                                <button type="button" class="btn btn-primary btn-primary-insv mr-2" @click="searchFilter">
                                    Search Clinics
                                </button>
                                <button type="button" class="btn btn-secondary" @click="resetFilter">
                                    Reset Search
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>

        <div class="table-responsive">
            <div ref="tableSection">
                <table ref="listTable" class="table table-hover">
                    <col width="50">
                    <col width="250">
                    <col>
                    <col>
                    <col v-if="isSuperAdmin" width="160">
                    <col width="100">
                    <col width="100">
                    <col width="150">
                    <thead>
                        <tr>
                            <th scope="col">#</th>
                            <th scope="col">Join Date</th>
                            <th scope="col">Clinic Name</th>
                            <th scope="col">Email Address</th>
                            <th v-if="isSuperAdmin" scope="col">Recruitment Type</th>
                            <th scope="col">Status</th>
                            <th scope="col">Approval</th>
                            <th scope="col">Action</th>
                        </tr>
                    </thead>

                    <tbody>
                        <tr v-show="clinicList.length === 0">
                            <td :colspan="columnsCount" class="text-center font-italic">
                                {{isTableLoading ? "Loading Data": "No Data"}}
                            </td>
                        </tr>
                        <tr v-for="(clinic, index) in clinicList" :key="index">
                            <th scope="row">{{((pagination.currentPage - 1) * pagination.pageSize ) + index + 1}}</th>
                            <td>{{clinic.joinedDate}}</td>
                            <td>{{clinic.name}}</td>
                            <td>{{clinic.email}}</td>
                            <td v-if="isSuperAdmin">
                                <template v-if="clinic.recruitmentType===1">
                                    IPH
                                </template>
                                <template v-else>
                                    Health Savvy
                                </template>
                            </td>
                            <td>
                                <span class="badge text-nowrap" :class="{
                                    'badge-success': clinic.isReviewed,
                                    'badge-secondary': !clinic.isReviewed,
                                }">
                                    {{clinic.isReviewed ? 'Reviewed' : 'Not Review Yet'}}
                                </span>
                            </td>
                            <td>
                                <template v-if="clinic.isReviewed">
                                    <span class="badge text-nowrap" :class="{
                                        'badge-success': clinic.isApproved && !clinic.isDisapproved,
                                        'badge-danger': clinic.isDisapproved,
                                    }">
                                        {{(clinic.isApproved && !clinic.isDisapproved) ? 'Approved' : 'Disapproved'}}
                                    </span>
                                </template>
                                <template v-else>
                                    <span class="badge badge-secondary text-nowrap">
                                        Not Review Yet
                                    </span>
                                </template>
                            </td>
                            <td>
                                <router-link :to="{
                                    'name': 'superadmin-clinic-approval',
                                    'params': {'id': clinic.clinicId}
                                }">
                                Review Clinic
                                </router-link>
                            </td>
                        </tr>
                    </tbody>

                </table>
            </div>

            <pagination v-model="pagination.currentPage"
                :totalPages="pagination.totalPages"
                :scrollPosition="pagination.scrollPosition">
            </pagination>
        </div>
    </div>
</template>

<script>
import {
    convertDateToIso8601,
    convertToUserReadableDateTime
} from '@/utilities';
import pagination from '@/components/pagination';
import {
    mask
} from 'vue-the-mask';
export default {
    'components': {
        pagination
    },
    'directives': {
        mask
    },
    'computed': {
        currentPage () {
            return this.pagination.currentPage;
        },
        isSuperAdmin () {
            return this.$store.state.user.userRole === 8;
        }
    },
    'watch': {
        currentPage () {
            this.$nextTick(() => {
                this.getClinics();
            });
        }
    },
    data () {
        return {
            'search': {
                'joinedDate': null,
                'clinicName': null,
                'emailAddress': null,
                'recruitmentType': -1,
                'reviewStatus': -1,
                'approvalStatus': -1
            },
            'columnsCount': 1,
            'isTableLoading': true,
            'pagination': {
                'currentPage': 1,
                'totalPages': 0,
                'pageSize': 20,
                'scrollPosition': 0
            },
            'clinicList': [],
            'recruitmentTypes': [
                {
                    'value': -1,
                    'text': 'All'
                },
                {
                    'value': 0,
                    'text': 'Health Savvy'
                },
                {
                    'value': 1,
                    'text': 'IPH'
                }
            ],
            'reviewStatuses': [
                {
                    'value': -1,
                    'text': 'All'
                },
                {
                    'value': 1,
                    'text': 'Reviewed'
                },
                {
                    'value': 0,
                    'text': 'Not Review Yet'
                }
            ],
            'approvalStatuses': [
                {
                    'value': -1,
                    'text': 'All'
                },
                {
                    'value': 1,
                    'text': 'Approved'
                },
                {
                    'value': 0,
                    'text': 'Disapproved'
                }
            ]
        };
    },
    mounted () {
        const pageContent = document.getElementsByClassName('page-content');
        pageContent[0].classList.add('wide-version');

        this.columnsCount = this.$refs.listTable.rows[0].cells.length;

        // initialize scroll position
        this.$nextTick(() => {
            this.pagination.scrollPosition = this.$refs.tableSection.getBoundingClientRect().top + window.scrollY - document.querySelector('.top-navigation').clientHeight;
        });

        this.getClinics();
    },
    destroyed () {
        const pageContent = document.getElementsByClassName('page-content');
        pageContent[0].classList.remove('wide-version');
    },
    'methods': {
        getClinics () {
            this.axios.post('clinic/GetAllClinics', {
                'p': this.pagination.currentPage,
                'ps': this.pagination.pageSize,
                'jd': this.search.joinedDate ? convertDateToIso8601(this.search.joinedDate) : null,
                'cn': this.search.clinicName,
                'ea': this.search.emailAddress,
                'rt': this.search.recruitmentType,
                'rs': this.search.reviewStatus,
                'as': this.search.approvalStatus
            }).then(({ data }) => {
                this.isTableLoading = false;
                let pagedResult = data.data;

                this.pagination.currentPage = pagedResult.p;
                this.pagination.totalPages = pagedResult.c;

                let list = pagedResult.l;

                this.clinicList = list.map((clinic) => ({
                    'isReviewed': clinic.ir,
                    'isApproved': clinic.ia && !clinic.id,
                    'isDisapproved': clinic.id,
                    'name': clinic.n ? clinic.n : '-',
                    'email': clinic.e ? clinic.e : '-',
                    'joinedDate': clinic.jd ? convertToUserReadableDateTime(clinic.jd) : '-',
                    'clinicId': clinic.i,
                    'recruitmentType': clinic.rt
                }));
            });
        },
        resetFilter () {
            this.search.joinedDate = null;
            this.search.clinicName = null;
            this.search.emailAddress = null;
            this.search.recruitmentType = -1;
            this.search.reviewStatus = -1;
            this.search.approvalStatus = -1;

            this.pagination.currentPage = 1;

            this.getClinics();
        },
        searchFilter () {
            this.pagination.currentPage = 1;

            this.getClinics();
        }
    }
};

</script>

<style>

</style>
